<div class="modal-dialog" cdkTrapFocus>
	<div class="goreact-modal-header" role="banner">
		<h1 class="modal-title">{{modalTitleValue()}}</h1>
		<button
			class="close-btn"
			type="button"
			[attr.aria-label]="('common_close' | translate)"
			(click)="cancel()">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div class="goreact-modal-body">
		<ngx-library-collection-viewer
			data-cy="library-modal-body"
			[filterType]="data.filterType"
			[mode]="data.mode"
			[previewable]="data.previewable"
			[create]="data.create"
			[openToOrg]="data.openToOrg"
			[collectionManagement]="collectionManagement"
			(selectItem)="selectItem($event.item)"
			(cancel)="cancel()">
		</ngx-library-collection-viewer>
	</div>
</div>
